import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import addUserIcon from "../../../assets/addUserIcon.svg"
import CardAsesores from "./CardAsesores"
import DetailAsesor from "./DetailAsesor"
import test from "../../../../Pages/assets/Animacion-nosotros.webm"
import CreateAsesor from "../../../../Components/Asesores/CreateAsesor"
import { getAllsAsesores, getAsesorById, getReporteActividadAsesor } from "../../../../endpoints"
import { useLocation, useParams } from "react-router-dom";
import CustomCircularProgress from "../../../../Components/Loading/CustomCircularProgress"
import ModalAsignarContactos from "../../../../Components/Asesores/ModalAsignarContactos/ModalAsignarContactos"
import { useWindowWidth } from "@react-hook/window-size";

const Asesores = ({ user }) => {
  const scrollContainerRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [modalCreateAsesor, setModalCreateAsesor] = useState(false);
  const [modalAsignarContactos, setModalAsignarContactos] = useState(false);
  const [asesores, setAsesores] = useState([]);
  const [selectedAsesor, setSelectedAsesor] = useState(null);
  const [refresh, setRefresh] = useState({
    value: 1
  })
  const [asesoresTotales, setAsesoresTotales] = useState(0);
  const params = useParams();
  const onlyWidth = useWindowWidth();

  useEffect(() => {
    if (params.id) {
      setLoading(true)
      getAsesorID()
    }
  }, [params]);

  const getAsesorID = () => {
    getAsesorById(params.id).then((res) => {
      if (res.status === 200) {
        setSelectedAsesor(res.data)
        setTimeout(() => {
          setLoading(false);
        }, 500);
      } else {
        setLoading(false)
      }
    })
  }

  const openModalCreateAsesor = () => {
    setModalCreateAsesor(true);
  }
  const closeModalCreateAsesor = () => {
    setModalCreateAsesor(false);
  }
  const handleFormClick = (e) => {
    e.stopPropagation(); // Evita que el evento de clic se propague hacia arriba
  };

  const getAsesores = async () => {
    getAllsAsesores(
      {
        page: currentPage,
        perPage: 35,
      }
    ).then((res) => {
      if (res.status === 200) {
        console.log(res.data)
        const newContacts = [...asesores, ...res.data.asesores];
        setAsesores(newContacts)
        setAsesoresTotales(res.data.total)
        setTotalPages(res.data.total / 30)
        setLoading(false)
      }
    
    })
  }
  useEffect(() => {
    setLoading(true)
    getAsesores()
  }, [currentPage]);

  const handleNextPage = (currentPage, totalPages) => {
    if (currentPage < totalPages) {
      let auxCurrent = currentPage + 1;
      setCurrentPage(auxCurrent);
    }
  };
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return; // Check if the ref is null

    const handleScroll = () => {
      if (scrollContainer.scrollHeight - scrollContainer.scrollTop === scrollContainer.clientHeight) {
        console.log("siguiente pagina")
        console.log(currentPage, "Dentro del scroll")
        handleNextPage(currentPage, totalPages);
      }
    };

    scrollContainer.addEventListener('scroll', handleScroll);

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [currentPage, scrollContainerRef.current, totalPages]);


  useEffect(() => {
    console.log(asesores)
  }, [asesores])

  return (
    <ContainerBox>

      <DivContentFilters params={params} selectedAsesor={selectedAsesor} >
        <DivRow>
          <DivColumn1>

            <Text1>{`Total: ${asesoresTotales}`}</Text1>

          </DivColumn1>
          {
            user.type !== "Admin" && user.type !== "Supervisor" ?
              null :
              <DivRow1>
                <ActionBtn
                  src={addUserIcon}
                  onClick={openModalCreateAsesor}
                />

              </DivRow1>
          }
        </DivRow>

        <Input
          type="text"
          placeholder="Buscar..."
        />

        <ScrollContainer ref={scrollContainerRef}>
          {asesores.map((asesor, index) => (
            <CardAsesores
              key={asesor.id}
              asesor={asesor}
              setSelectedAsesor={setSelectedAsesor}
              selectedAsesor={selectedAsesor}
            />
          ))}

        </ScrollContainer>
      </DivContentFilters>

      <DivFlexColumn params={params} >
        {
          loading === false && selectedAsesor?.id !== undefined ? (
            <DetailAsesor
              setModalAsignarContactos={setModalAsignarContactos}
              selectedAsesor={selectedAsesor}
              getReporteActividadAsesor={getReporteActividadAsesor}
              user={user}
              refresh={refresh}
            />
          ) : loading === false && !selectedAsesor?.id ? (
            <VideoCont src={test}
              autoPlay
              loop
            ></VideoCont>
          ) : (
            <CustomCircularProgress size={50} padding='15vw' />
          )
        }
      </DivFlexColumn>

      {
        modalCreateAsesor ?
          <CreateAsesor
            closeModalCreateAsesor={closeModalCreateAsesor}
            stopPropagation={handleFormClick}
            getAsesores={getAsesores}
            setAsesores={setAsesores}
          /> : null
      }

      {
        modalAsignarContactos ?
          <ModalAsignarContactos
            closeModalAsignarContactos={setModalAsignarContactos}
            stopPropagation={handleFormClick}
            refresh={refresh}
            asesorId={selectedAsesor.id}
            setRefresh={setRefresh}

          />
          : null
      }

    </ContainerBox>
  )

}


export default Asesores
const VideoCont = styled.video`
  border-radius: 8px;
  height: auto;
  width: 50%;
  margin: 15%;
`;

const DivContentFilters = styled.div`
  width: 25vw;
  min-width:280px;
  max-width: 350px;
  height: auto;
  min-height: 98vh!important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0px;
  padding: 0px 0px 8px 24px;
  background-color: #FFFFFF;
  @media only screen and (min-width:0px) and (max-width:1100px){
    display:${(prop) => prop.params.id ? 'none' : 'flex'};
    width: -webkit-fill-available;
  }
`;

const DivFlexColumn = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  width: -webkit-fill-available;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  max-height: 85vh;
  min-height: 85vh;
  overflow-y: auto;
  border-radius: 8px;
  margin-right: 16px;
  margin-top: 8px;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

  @media only screen and (min-width:0px) and (max-width:1100px){
    display:${(prop) => prop.params.id ? 'flex' : 'none'};
    margin-right: 0px;
  }
`;

const ActionBtn = styled.img`
  max-width:28px;
  max-height:28px;
  width:28px;
  height:28px;
  border-radius: 8px;
  border-color: #dadce0;
  box-shadow: rgba(0, 0, 0, .1) 0 1px 1px;
  background-color: #FFFFFF;
  padding:5px;
  cursor:pointer;
  &:active{
    zoom: 95%;
  }
`;


const Input = styled.input`
  box-shadow: rgb(0 0 0 / 6%) 0px 2px 4px 0px inset;
  width: -webkit-fill-available;
  min-width: -webkit-fill-available;
  margin: 8px 8px;
  padding:5px;
  border:none;
  outline: none;
  background:#FFFFFF;
  border-radius:8px;
  height:26px;
  min-height:26px;
  max-width: 10vw;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #07082c;

  &:placeholder{
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #07082c;
  }
`;

const ContainerBox = styled.div`
  width: -webkit-fill-available;
  height: auto;
  min-height: 95vh;
  max-height: 95vh;
  overflow-y: hidden;
  max-width: calc(100vw - 84px);
  gap: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 1% 16px 0px 1%;
  background-color:#FFFFFF;
  border-radius:8px;
  box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
  border: 1px solid var(--Neutral-Gray-Gray-100, #E0E2E7);
  @media only screen and (min-width:0px) and (max-width:1100px){
    margin: 5vh 0px 0px 0px;
    max-width: calc(100vw - 0px);
  }
`;

const DivRow = styled.div`
  width: -webkit-fill-available;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 0.5em 0.5em 0.5em;
  justify-content: space-between;
`;

const DivColumn1 = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`;
const DivRow1 = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 5px;
`;
const ScrollContainer = styled.div`
  width: -webkit-fill-available;
  height: auto;
  max-height: calc(100vh - 31vh) !important;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0%;
  scroll-behavior: smooth;
  padding: 8px 0px 0px 0px;
  border-top: 2px solid #003049;
  justify-content: flex-start;
  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

`;

const Text1 = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #003049;
`;
